import React from "react";
import PropTypes from "prop-types";
import { useLive } from "../LiveProvider";
import IllustrationAboutMe from "../../illustrations/IllustrationAboutMe";
import Preview from "./LivePreview";

function LivePreviewAboutMe({ title }) {
  const { agent } = useLive();

  return (
    <Preview
      illustration={<IllustrationAboutMe />}
      title={title}
      subTitle={agent.name || "N/A"}
    />
  );
}

LivePreviewAboutMe.propTypes = {
  title: PropTypes.string.isRequired
};

export default LivePreviewAboutMe;
